import React, { useMemo, useState } from 'react';
import { Box, Typography, Button, IconButton } from '@mui/material';
import { ReactTable } from '@components';
import { MRT_ToggleGlobalFilterButton } from 'material-react-table';
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import UploadFile from './UploadFile';
import { showToast } from '@utils';
import { useGetFileConfigsQuery, useDeleteFileConfigMutation } from '../../../../../../store/feature/chat/knowledgeBase';

const File = () => {
    const {
        data: fileConfigs,
        isLoading: isLoadingFiles,
        refetch
    } = useGetFileConfigsQuery();
    const [isFilesEnabled, setIsFilesEnabled] = useState(false);
    const [showUploadFile, setShowUploadFile] = useState(false);

    // Handle navigation to UploadFile
    const handleAddFile = () => {
        setShowUploadFile(true);
    };

    // Handle navigation back to file list
    const handleBackToFileList = () => {
        setShowUploadFile(false);
        // Refresh file list when returning
        refetch();
    };

    const [deleteFileConfig] = useDeleteFileConfigMutation();

    // delete file api
    const handleDelete = (filename) => {
        if (window.confirm('Are you sure you want to delete this file?')) {
            try {
                deleteFileConfig({ filenames: [filename] })
                    .then((resp) => {
                        if (!resp?.error) {
                            refetch();
                        showToast('success', 'File deleted successfully');
                    } else {
                        showToast('error', 'Failed to delete file');
                    }
                });
        } catch (error) {
            console.error('Error deleting file:', error);
            }
        }
    };

    const columns = useMemo(
        () => [
            {
                header: 'File Name',
                id: 'file_name',
                accessorFn: ({ file_name }) => file_name || '',
                Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>
            },
            // {
            //     header: 'Size',
            //     id: 'size',
            //     accessorFn: ({ size }) => size || '',
            //     Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>
            // },
            {
                header: 'Type',
                id: 'file_type',
                accessorFn: ({ file_type }) => file_type || '',
                Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>
            },
            {
                header: 'Upload Date',
                id: 'created_at',
                accessorFn: ({ created_at }) => created_at || '',
                Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>
            }
        ],
        []
    );

    const actionsMenu = useMemo(
        () =>
            ({ row }) =>
                [
                    <Button
                        variant="outlined"
                        color="error"
                        sx={{
                            p: 0,
                            m: 0,
                            borderColor: 'brown',
                            color: 'brown',
                            fontSize: '13px',
                            '&:hover': {
                                borderColor: 'brown',
                                color: 'white',
                                backgroundColor: 'brown'
                            }
                        }}
                        onClick={() => handleDelete(row?.original?.file_url)}
                    >
                        Delete
                    </Button>
                ],
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    return (
        <Box sx={{ p: 3, height: '100%', overflow: 'auto' }}>
            {showUploadFile ? (
                <UploadFile onBack={handleBackToFileList} />
            ) : (
                /* Files Table */
                <ReactTable
                    columns={columns}
                    data={fileConfigs || []}
                    actions={actionsMenu}
                    isLoading={isLoadingFiles}
                    renderToolbarInternalActions={({ table }) => (
                        <Box onMouseDown={(e) => e.stopPropagation()}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1
                                }}
                            >
                                {/* Files Count */}
                                {isFilesEnabled && fileConfigs?.length > 0 && (
                                    <Typography
                                        variant="caption"
                                        color="primary"
                                        sx={{ fontWeight: 600, mr: 2 }}
                                    >
                                        ({fileConfigs?.length} files selected)
                                    </Typography>
                                )}

                                {/* Private Knowledge Switch */}
                                {/* <FormControlLabel
                                    control={
                                        <Switch
                                            checked={isFilesEnabled}
                                            onChange={(e) => {
                                                setIsFilesEnabled(e.target.checked);
                                            }}
                                            color="primary"
                                            size="small"
                                        />
                                    }
                                    label="Enable"
                                    labelPlacement="start"
                                    sx={{ mr: 2 }}
                                /> */}

                                {/* Add File Button */}
                                <IconButton
                                    size="small"
                                    onClick={handleAddFile}
                                >
                                    <AddBoxOutlinedIcon />
                                </IconButton>

                                {/* eslint-disable-next-line react/jsx-pascal-case */}
                                <MRT_ToggleGlobalFilterButton table={table} />
                            </Box>
                        </Box>
                    )}
                    headerText={`Uploaded Files (${fileConfigs?.length || 0})`}
                />
            )}
        </Box>
    );
};

export default File;
